import { TransTokens } from "../i18n/trans-tokens";
import { Translation } from "../i18n/translation";

const tokens = TransTokens.create({
  UnknownError: "An unspecified error occurred: {{message}} ",
  NoDetails: "no details for this error.",
});

export class LocalizedError extends Error {
  public name = "Error";

  public doNotCapture = false;

  public get message() {
    return this.translationMessage.interpolate({
      message: this.underlyingError?.message,
      ...this.translationTokens,
    });
  }

  constructor(
    private underlyingError: Error = new Error("unknown"),
    public translationMessage: Translation = tokens.UnknownError,
    public translationTokens: { [key: string]: any } = {}
  ) {
    super();
  }

  public get originalError() {
    return this.underlyingError;
  }

  public get originalMessage() {
    return (
      (this.originalError as any).response?.data?.message ||
      this.originalError.message
    );
  }
}
